import { createFileRoute } from '@tanstack/react-router'
import { useNavigate, useSelector } from '@spcc/core'
import { useEffect } from 'react'
import { selectIsAdmin } from '@spcc/domains/admin-context'
import { KioskWeighbridgeSection } from '@spcc/domains/shipments'

export const Route = createFileRoute('/weighbridge')({
  component: WeighbridgePage,
})

function WeighbridgePage() {
  const isAdmin = useSelector(selectIsAdmin)
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAdmin) {
      navigate({ to: '/scan' })
    }
  }, [isAdmin, navigate])

  if (!isAdmin) return null

  return <KioskWeighbridgeSection />
}
